import _get from 'lodash/get'

import type {
  AnySimpleOnPrepareHook,
  AnySimpleOnSubmitHook,
  FlowValues,
} from '@flows/core/types/stepTypes'
import type { ProductKey } from '@flows/insurance/types/products'

/* Those onPrepare and onSubmit are necessary
 * There can be a cases where we can have two birthday({ type: 'date' }) steps in one flow
 * For example in legal-contents there are two steps legal_birthday and contents_birthday
 * Both of them have different names. And second should be prefilled
 * More info here: https://github.com/nxt-insurance/frontend-commons/pull/68#discussion_r638695184
 */
export const updateDateOnPrepareHook = (
  getParamPath: (name: string, productKey?: ProductKey) => string
) =>
  ({
    type: 'simpleHook',
    callback: (flowValues: FlowValues) => {
      if (flowValues.born_on !== undefined) {
        return {
          formValues: {
            [getParamPath('born_on')]: flowValues.born_on,
          },
        }
      }
    },
  }) as const satisfies AnySimpleOnPrepareHook
export const updateDateOnSubmitHook = (
  getParamPath: (name: string, productKey?: ProductKey) => string
) => {
  return {
    type: 'simpleHook',
    callback: (flowValues: FlowValues) => {
      return {
        formValues: {
          born_on: _get(flowValues, getParamPath('born_on')),
        },
      }
    },
  } as const satisfies AnySimpleOnSubmitHook
}
